import type { Moment } from 'moment';
import moment, { getConfiguredMomentTimezone } from 'utils/moment';

const DATETIME_FMT = 'MM-DD-YYYY HH:mm:ss';

const resolveZone = (): string => getConfiguredMomentTimezone() || moment.tz.guess();

export const formatDuration = (minuteValue: number) => {
  if (!minuteValue || minuteValue < 0) return '00:00:00';
  if (minuteValue < 60) return `00:${minuteValue}:00`;
  const hour = Math.floor(minuteValue / 60);
  const minute = minuteValue - hour * 60;
  return `${hour > 9 ? hour : '0' + hour}:${minute > 9 ? minute : '0' + minute}:00`;
};

/** Parses server datetime strings in the app (salon) timezone, not the browser's local zone. */
export const momentTimezone = (val: unknown): Moment => {
  const zone = resolveZone();
  if (val == null || val === '') {
    return moment.tz(zone);
  }
  if (moment.isMoment(val)) {
    return moment.tz(val as Moment, zone);
  }
  return moment.tz(val as string, DATETIME_FMT, zone);
};
const PURE_DATE_FORMAT = 'MM-DD-YYYY hh:mm A';
export const getSystemMomentFormat = (dateTime: Moment | null | undefined) => {
  if (!dateTime) return '';
  return moment(dateTime?.format(PURE_DATE_FORMAT), PURE_DATE_FORMAT)?.format();
};
